import {
  CtaBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { NEED_MORE_INFO } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";

import {
  GoToBrandReferralsCTA,
  GoToFairePosCTA,
  ReportItemsCTA,
  RequestExtensionCTA,
  VerifyAccountCTA,
  ViewInvoicesCTA,
  ViewOrUpdatePaymentMethodsCTA,
  ViewOrderInvoiceCTA,
} from "./ctas";

export const NEED_MORE_INFO_ANSWER = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => ({
  getTitle: () => NEED_MORE_INFO(strictLocalize),
  getDescription: () => [CHECKOUT_OUR_ARTICLES(strictLocalize)],
});

const CHECKOUT_OUR_ARTICLES = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Check out some recommended articles from our Help Center below, or contact us if you need more help.",
  });

export const INELIGIBLE_FOR_REPORT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Your 14-day period to report damaged, missing, or incorrect items for this order has passed",
    description: {
      text: "Title for the answer of report a damage item or shipment issue if the selected order delivery has passed more than 14 days",
    },
  });

export const DO_NOT_PROCESS_DAMAGED_AS_RETURN = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Note: Please do not process damaged items as a “return” to avoid being charged at a later date.",
  });

export const TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Please note that VAT, excise taxes, and other fees are not covered by Faire.",
    description: {
      text: "Part of the support answer shown to retailers explaining how duties work with Faire orders",
    },
  });

export const getReportItemsOrRequestExtensionCTA: CtaBuilderFn = (
  context,
  strictLocalize
) => {
  const { brandOrder, shippingContext } = context;
  const deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return undefined;
  }

  return orderCanBeReportedBasedOnDeliveryDate(deliveredAt)
    ? ReportItemsCTA(strictLocalize)
    : RequestExtensionCTA(strictLocalize);
};

export const getVerifyAccountCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return VerifyAccountCTA(strictLocalize);
};

export const getGoToFairePosCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return GoToFairePosCTA(strictLocalize);
};

export const getViewOrderInvoiceCTA: CtaBuilderFn = (
  context,
  strictLocalize
) => {
  const { brandOrder } = context;
  if (!brandOrder) {
    return undefined;
  }

  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};

export const getViewSingleOrMultipleInvoicesCTA: CtaBuilderFn = (
  context,
  strictLocalize
) => {
  const { brandOrder } = context;
  if (!brandOrder) {
    return ViewInvoicesCTA(strictLocalize);
  }

  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};

export const getViewAndUpdatePaymentMethodsCTA: CtaBuilderFn = (
  _context,
  strictLocalize
) => {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};

export const getGoToBrandReferralsCTA: CtaBuilderFn = (
  _context,
  strictLocalize
) => {
  return GoToBrandReferralsCTA(strictLocalize);
};
